import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  AddToCardQuery,
  AddToCardVo,
  PutToCardQuery,
  DelToCardQuery,
  AddToCardBatchQuery,
  ShoppingCartBatchAddVo,
  CartDataCatchDTO
} from './type';

/**
 * 新增购物车
  POST /api/order/cart
  接口ID：234956487
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956487
 */
export const post2Cart = (data: AddToCardQuery): AxiosPromise<AddToCardVo> => {
  return request({
    url: '/api/order/cart',
    method: 'post',
    data
  });
};

/**
 * 修改购物车(废弃)
PUT /api/order/cart
接口ID：234956486
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956486
  */
export const post2CartEdit = (data: PutToCardQuery): AxiosPromise => {
  return request({
    url: '/api/order/cart/edit',
    method: 'post',
    data
  });
};

/**
 * 删除购物车
DELETE /api/order/cart/{cartId}
接口ID：234956491
接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956491
 */
export const del2Cart = (params: DelToCardQuery): AxiosPromise => {
  return request({
    url: `/api/order/cart/${params.cartId}`,
    method: 'delete',
    params: {
      touristId: params.touristId
    }
  });
};

/**
 * 批量新增购物车
  POST /api/order/cart/add/batch
 */
export const post2CartBatch = (data: AddToCardBatchQuery): AxiosPromise<ShoppingCartBatchAddVo> => {
  return request({
    url: '/api/order/cart/add/batch',
    method: 'post',
    data
  });
};

// 购物车埋点
export const post2CartDataCatch = (data: CartDataCatchDTO) => {
  return request({
    url: '/product/urlMapping/game-service/addPurchaseBurialPoint',
    method: 'post',
    data
  });
};

// 保存发货信息
// POST /api/order/buyer/save/delivery/info
// 接口ID：334029299
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-334029299
export const postSaveBuyNowDeliverInfo = (data: AddToCardQuery) => {
  return request({
    url: '/api/order/buyer/save/delivery/info',
    method: 'post',
    data
  });
};
